module.exports = __webpack_public_path__ + "img/001.c87c79f5.jpg";